module.exports = __webpack_public_path__ + "static/media/map_top.8e9eb03a.png";